import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../Components/Header/Header';
import Footer from '../Components/Footer/Footer';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found-page">
            <div className="container">
                <Header type="primary" />
                <div className="content-wrap bg-gradient-light">
                    <div className="content-wrap-inner">
                        <div className="not-found-content">
                            <div className="error-code">404</div>
                            <h1 className="error-title">Page Not Found</h1>
                            <p className="error-message">
                                Oops! The page you're looking for doesn't exist or has been moved.
                            </p>
                            <div className="error-actions">
                                <Link to="/" className="btn-home button-right-arrow hover-bounce">
                                    Back to Home <span className="arrow-right"></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
};

export default NotFound;
